import { atom, useAtomValue } from 'jotai'
import { env$ } from '~/stores/env'
import { usePayPayMessage } from '../../store/payment'
import { usePlan, useRestaurant } from '../../store/stateMachine/state'

export function useUsageErrorMessage() {
  const isSeatOnly = usePlan()?.isSeatOnly ?? false
  const pointAvailable = useRestaurant()?.pointAvailable ?? false
  const hasError = usePayPayMessage() === 'invalidYahooIdToken'
  return { isSeatOnly, pointAvailable, hasError }
}

function encodedHref() {
  return encodeURIComponent(window.location.href)
}

const yahooConnectUrl$ = atom((get) => {
  const env = get(env$)
  return `${
    env.MEMBER_ORIGIN
  }/member/oauth/yid?dest=${encodedHref()}&back=dest&nomailmatch=true&type=ikyu`
})
yahooConnectUrl$.debugLabel = 'yahooConnectUrl$'

export function useYahooConnectUrl() {
  return useAtomValue(yahooConnectUrl$)
}
